import * as React from 'react';
import { 
  Box,
  CircularProgress,
  DialogContent,
  IconButton,
  Select,
  FormControl,
  InputLabel,
  MenuItem
} from '@mui/material';

import { useSelector, useDispatch } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import { CDialog, CDialogTitle, CDialogActions, CButton, CTextField } from '../../components/common/Modal';

import { createGroup, updateGroup } from '../../slices/group';

export default function GroupModal(props) {
  const {open, mode, data, handleClose} = props;

  const [loading, setLoading] = React.useState(false);
  const [name, setName] = React.useState(mode === 'Create'?"":data.name);
  const [apiKey, setApiKey] = React.useState(mode === 'Create'?"":data.apiKey);

  const dispatch = useDispatch();  

  React.useEffect(() => {
    if(mode === 'Update'){
      setName(data.name);
      setApiKey(data.apiKey);
    }
    else {
      setName("");
      setApiKey(data.apiKey);
    }
  }, [mode, data])

  const handleSave = (e) => {
    if(name === "" || apiKey === "") return;

    let formData = new FormData();
    formData.append('name', name);
    formData.append('api_key', apiKey);
    if(mode === 'Update')
      formData.append('id', data.id);

    setLoading(true);
    if(mode === 'Create') {
      dispatch(createGroup(formData))
        .unwrap()
        .then(res => {
          setLoading(false);
          window.alert("Create new group successfully!");
          setName("");
          setApiKey("");
          handleClose();
        })
        .catch(err => {
          console.log(err);
          setLoading(false);
        }      
      )
    }
    else {
      dispatch(updateGroup(formData))
        .unwrap()
        .then(res => {
          setLoading(false);
          window.alert("Update new group successfully!");
          setName("");
          setApiKey("");
          handleClose();
        })
        .catch(err => {
          console.log(err);
          setLoading(false);
        }      
      )
    }
  }
 
  return (
    <>
      <CDialog
        open={open}
        onClose={handleClose}
        maxWidth={"sm"}
        fullWidth
      >
        <CDialogTitle>New Group</CDialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 6,
            top: 6,
            color: (theme) => theme.palette.grey[800],
          }}
        >
          <CloseIcon fontSize='small' />
        </IconButton>
        <DialogContent>
        <CTextField
          id={`groupname`} 
          label={`Group Name`}
          size="small"
          variant="outlined"
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
        />
        <CTextField
          id={`apiKey`} 
          label={`API Key`}
          size="small"
          variant="outlined"
          value={apiKey}
          onChange={(e) => setApiKey(e.target.value)}
          sx={{
            marginTop: '1rem'
          }}
          fullWidth
        />
        {loading && (
            <Box className="absolute w-full h-full" sx={{top: 0, left: 0}}>
              <Box className="relative w-full h-full">
                <Box className="w-full h-full flex justify-center align-center">
                  <CircularProgress sx={{opacity: 0.7}} />
                </Box>
              </Box>
            </Box>)
          }  
        </DialogContent>
        <CDialogActions>
          <CButton onClick={handleClose}>Cancel</CButton>
          <CButton onClick={handleSave}>Ok</CButton>
        </CDialogActions>
      </CDialog>
    </>
  )
}